import { Directive } from '@angular/core';
import { NgpDescription } from 'ng-primitives/form-field';

@Directive({
  selector: '[sui-hint]',
  standalone: true,
  hostDirectives: [NgpDescription],
})
export class SuiHintDirective {}
